import { cn } from '@/lib/utils';
import type { TravelEsimSummary } from '@octave/contracts';

interface TravelEsimTargetNoticeProps {
  existingEsim: TravelEsimSummary | undefined;
  newEsim: boolean;
  beneficiaryLabel: string;
  email: string;
  onNewEsimChange: (newEsim: boolean) => void;
}

/**
 * Tells the client where the plan will land: on the beneficiary's existing
 * eSIM (a recharge, the default when they have one) or on a new eSIM whose
 * QR code goes to the e-mail given. One click switches between the two.
 */
export function TravelEsimTargetNotice({
  existingEsim,
  newEsim,
  beneficiaryLabel,
  email,
  onNewEsimChange,
}: TravelEsimTargetNoticeProps) {
  const recharge = !!existingEsim && !newEsim;
  return (
    <div
      className={cn(
        'rounded-xl border px-4 py-3 text-sm',
        recharge
          ? 'border-violet-200 bg-violet-50 text-violet-800'
          : 'border-slate-200 bg-slate-50 text-slate-600',
      )}
    >
      {existingEsim ? (
        recharge ? (
          <>
            <p>
              {beneficiaryLabel || 'Ce bénéficiaire'} a déjà une eSIM
              internationale
              {existingEsim.esimNumber ? ` (n° ${existingEsim.esimNumber})` : ''}
              . Ce forfait sera chargé dessus, sans nouveau QR code.
            </p>
            <button
              type="button"
              onClick={() => onNewEsimChange(true)}
              className="mt-1 text-xs font-medium underline cursor-pointer"
            >
              Commander une nouvelle eSIM à la place
            </button>
          </>
        ) : (
          <>
            <p>Une nouvelle eSIM sera créée et son QR code envoyé à {email}.</p>
            <button
              type="button"
              onClick={() => onNewEsimChange(false)}
              className="mt-1 text-xs font-medium underline cursor-pointer"
            >
              Recharger l'eSIM existante plutôt
            </button>
          </>
        )
      ) : (
        <p>
          Une eSIM sera créée et son QR code envoyé à{' '}
          {email || 'l’adresse indiquée'}.
        </p>
      )}
    </div>
  );
}
